// src/services/reportsService.js

// ⚠️ URL BASE ACTUALIZADA A PRODUCCIÓN
const BASE_URL = "https://ws-prd.enlaparadave.com/v1/websocket/reports";

// ==========================================================
// 🔥 REPORTES DE GENERACIÓN DE RUTAS
// ==========================================================

/**
 * Obtiene los diccionarios de rutas modificadas por el algoritmo
 */
export const getGenerationReports = async (token) => {
  try {
    console.log("📤 Solicitando reportes de generación...");

    const response = await fetch(`${BASE_URL}/generation`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}` 
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }

    const data = await response.json();
    console.log("📥 Reportes de generación recibidos:", data);
    return data;
    
  } catch (error) {
    console.error("❌ Error obteniendo los reportes:", error);
    throw error;
  }
};

/**
 * Revierte los cambios de una ruta a su estado del día anterior
 */
export const revertRouteGeneration = async (rouId, token) => {
  try {
    console.log(`📤 Solicitando reversión para la ruta ID: ${rouId}...`);

    const response = await fetch(`${BASE_URL}/generation/revert/${rouId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }

    // Usamos .text() porque el backend devuelve un String plano, no un JSON
    const data = await response.text(); 
    console.log("📥 Respuesta de reversión:", data);
    return data;
    
  } catch (error) {
    console.error(`❌ Error al intentar revertir la ruta ${rouId}:`, error);
    throw error;
  }
};

// ==========================================================
// 🔥 REPORTES DE INCIDENCIAS (NUEVO)
// ==========================================================

/**
 * Obtiene la lista de incidencias activas (desvíos) detectadas por el algoritmo
 */
export const getIncidentReports = async (token) => {
  try {
    console.log("📤 Solicitando reportes de incidencias...");

    const response = await fetch(`${BASE_URL}/incidents`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}` 
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }

    const data = await response.json();
    console.log("📥 Reportes de incidencias recibidos:", data);
    return data;
    
  } catch (error) {
    console.error("❌ Error obteniendo los reportes de incidencias:", error);
    throw error;
  }
};

/**
 * Revierte una incidencia, restaurando la ruta original y limpiando el mapa en vivo
 */
export const revertIncident = async (rouId, token) => {
  try {
    console.log(`📤 Solicitando reversión de incidencia para la ruta ID: ${rouId}...`);

    const response = await fetch(`${BASE_URL}/incidents/revert/${rouId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }

    // El backend responde con un String plano ("Incidencia revertida con éxito...")
    const data = await response.text(); 
    console.log("📥 Respuesta de reversión de incidencia:", data);
    return data;
    
  } catch (error) {
    console.error(`❌ Error al intentar revertir la incidencia en la ruta ${rouId}:`, error);
    throw error;
  }
  
};

export const getBusDailyActivity = async (token) => {
  try {
    const response = await fetch(`${BASE_URL}/bus-activity`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      signal: AbortSignal.timeout(15000) // si se cuelga, devolvemos [] en vez de esperar para siempre
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: No se pudo obtener la actividad diaria de los buses`);
    }

    // Retorna el array JSON que envía el backend
    return await response.json();
  } catch (error) {
    console.error("Error en getBusDailyActivity:", error);
    // Retornamos un array vacío para mantener la consistencia con tu getAllCities
    // y evitar que la app crashee si se intenta hacer un .map() o .filter()
    return []; 
  }
};